import React from "react";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const CarListingTable = ({
  listings,
  metaListings,
  language,
  onEdit,
  onDelete,
  onView,
  onPageChange,
}) => {
  if (!metaListings) return null;

  const {
    current_page,
    last_page,
    from,
    to,
    total,
    prev_page_url,
    next_page_url,
  } = metaListings;

  const pages = Array.from({ length: last_page }, (_, i) => i + 1);

  const labels = {
    car: { ar: "السيارة", en: "Car" },
    price: { ar: "السعر", en: "Price" },
    status: { ar: "الحالة", en: "Status" },
    year: { ar: "السنة", en: "Year" },
    fuel: { ar: "الوقود", en: "Fuel" },
    gear: { ar: "القير", en: "Gear" },
    area: { ar: "المنطقة", en: "Area" },
    description: { ar: "الوصف", en: "Description" },
    actions: { ar: "الإجراءات", en: "Actions" },
    yes: { ar: "نعم", en: "Yes" },
    no: { ar: "لا", en: "No" },
  };

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1100px] text-center">
          <thead className="bg-muted border-b">
            <tr>
              <th className="px-6 py-4">{labels.car[language]}</th>
              <th className="px-6 py-4">{labels.price[language]}</th>
              <th className="px-6 py-4">{labels.status[language]}</th>
              <th className="px-6 py-4">{labels.year[language]}</th>
              <th className="px-6 py-4">{labels.fuel[language]}</th>
              <th className="px-6 py-4">{labels.gear[language]}</th>
              <th className="px-6 py-4">{labels.area[language]}</th>
              <th className="px-6 py-4">{labels.description[language]}</th>
              <th className="px-6 py-4">{labels.actions[language]}</th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {listings?.map((car) => (
              <tr key={car.id} className="hover:bg-muted/40 transition">
                
                {/* car info */}
                <td className="px-6 py-4">
                  <div className="flex items-center justify-center gap-3">
                    <Image
                      src={car?.images?.[0]?.media_link}
                      alt=""
                      className="w-12 h-12 rounded-lg object-cover"
                    />
                    <div className="text-start">
                      <div className="font-medium">
                        {car?.car_brand?.name} {car?.car_model}
                      </div>
                      <div className="text-xs text-text-secondary">
                        {car?.owner}
                      </div>
                    </div>
                  </div>
                </td>

                {/* price */}
                <td className="px-6 py-4 font-semibold text-primary">
                  {car.price}
                </td>

                {/* status */}
                <td className="px-6 py-4">
                  <span className="px-3 py-1 rounded-full bg-muted">
                    {car.car_status === "OLD"
                      ? language === "ar"
                        ? "مستعملة"
                        : "Old"
                      : language === "ar"
                      ? "جديدة"
                      : "New"}
                  </span>
                </td>

                {/* year */}
                <td className="px-6 py-4">{car.car_year}</td>

                {/* fuel */}
                <td className="px-6 py-4">
                  {car?.fuel_type?.name}
                </td>

                {/* gear */}
                <td className="px-6 py-4">
                  {car?.gear_type?.name}
                </td>

                {/* area */}
                <td className="px-6 py-4">
                  {car?.area?.area_name}
                </td>

                {/* description */}
                <td className="px-6 py-4 max-w-[200px] truncate">
                  {car.description}
                </td>

                {/* actions */}
                <td className="px-6 py-4">
                  <div className="flex justify-center gap-2">
                    <button
                      onClick={() => onView(car)}
                      className="p-2 rounded-lg hover:bg-info/10 text-info"
                    >
                      <Icon name="Eye" size={16} />
                    </button>

                    <button
                      onClick={() => onEdit(car)}
                      className="p-2 rounded-lg hover:bg-primary/10 text-primary"
                    >
                      <Icon name="Edit2" size={16} />
                    </button>

                    <button
                      onClick={() => onDelete(car)}
                      className="p-2 rounded-lg hover:bg-error/10 text-error"
                    >
                      <Icon name="Trash2" size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center p-4 bg-muted/30 gap-3">
        <span className="text-sm text-text-secondary">
          {from}-{to} من {total}
        </span>

        <div className="flex gap-1 flex-wrap">
          <Button
            size="sm"
            variant="outline"
            disabled={!prev_page_url}
            onClick={() => onPageChange(current_page - 1)}
          >
            السابق
          </Button>

          {pages.map((page) => (
            <Button
              key={page}
              size="sm"
              variant={page === current_page ? "default" : "outline"}
              onClick={() => onPageChange(page)}
            >
              {page}
            </Button>
          ))}

          <Button
            size="sm"
            variant="outline"
            disabled={!next_page_url}
            onClick={() => onPageChange(current_page + 1)}
          >
            التالي
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CarListingTable;